import {
  Box,
  Grid,
  Paper,
  Toolbar,
  Typography,
  Button,
  Card,
  useTheme,
  useMediaQuery,
  Modal,
  ListSubheader,
  Slide,
  IconButton,
  Tooltip,
  Stack,
  Checkbox,
  Badge,
  Snackbar,
  Alert,
  CircularProgress,
  Skeleton,
  ButtonGroup,
  Breadcrumbs,
  Avatar,
  Container,
  ListItemButton,
  List,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  FaGithub,
  FaLinkedinIn,
  FaSkype,
  FaStackOverflow,
} from "react-icons/fa";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import introImg from "../../../Components/images/intro.png";
import SkypeIcon from "@mui/icons-material/Chat";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import VerifiedIcon from "@mui/icons-material/CheckCircle";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import React, { useEffect, useRef, useState } from "react";
import {
  Email,
  Phone,
  LinkedIn,
  GitHub,
  Edit,
  Verified,
  CheckBox,
  VerifiedRounded,
  DeleteRounded,
} from "@mui/icons-material";
import ResumePdfViewer from "../../candidatesPage/ResumePdfViewer";
import ResumesList from "../../candidatesPage/candidateResumesSection/ResumesList";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";

import moment from "moment";
import { Divider } from "@mui/material";
import FileUploader from "../../candidatesPage/ResumesUpload";
import {
  candidateSelectedResumeAction,
  creteNotificationAction,
  deleteResumeAction,
  getCandidateDetailAction,
  getPrimaryResumeDetailsAction,
  selectedCandidateAction,
  updatePrimaryResumeAction,
} from "../../redux/action";

import { userSelector } from "../../user-redux/selector";
import CandidateResumeUpload from "./ResumeUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { PersonOutlineRounded } from "@mui/icons-material";
import CandidateDetailsView from "../../candidatesPage/CandidateDetailsView";
import DeleteIcon from "@mui/icons-material/Delete";
import { TextField } from "@mui/material";
import Close from "@mui/icons-material/Close";
import Key from "../../../clientVariables.json";
import InputMask from "react-input-mask";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import LoadingListSkeleton from "../../loadingSkeletons/LoadingList";

export default function CandidateProfiles() {
  const dispatch = useDispatch();
  const { candidateDetails, primaryResumeDetails } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const [resumes, setResumes] = useState();
  const [selectedResume, setSelectedResume] = useState();
  const theme = useTheme();
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const openFileUploadRef = useRef(null);
  const [resumesRefresh, setResumesRefresh] = useState(false);
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs")); // Very small mobile devices
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm")); // Regular mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // Desktops and larger
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [hoverIndex, setHoverIndex] = useState(null);
  const [open, setopen] = useState("resume_view");
  const [loading, setLoading] = useState(false);
  const [resumesLoading, setResumesLoading] = useState(true);
  const [candidateId, setCandidateId] = useState("");
  const [resumeCheckedLength, setResumeCheckedLength] = useState(0);
  const [resumesChecked, setResumesChecked] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState("");
  const [editedPhone, setEditedPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [editedLinkedIn, setEditedLinkedIn] = useState("");
  const [editedGitHub, setEditedGitHub] = useState("");
  const [editedSkype, setEditedSkype] = useState("");
  const [editedStackOverflow, setEditedStackOverflow] = useState("");
  const [editPopupOpen, setEditPopupOpen] = useState(false);


  // State to track the selected button, 'resume' is the default value
  const [selectedButton, setSelectedButton] = useState("resume_view"); // Default is 'resume'

  const handleToggle = (value) => {
    setSelectedButton(value);
  };

  // const videoHight = useResponsiveVedio(160);

  useEffect(() => {
    const fetch = async () => {
      const response = await dispatch(
        getCandidateDetailAction(user?.candidate_id)
      );

      setCandidateId(response.candidate);

      await dispatch(selectedCandidateAction(response.candidate));

      await getCandidateResumeList();
    };
    fetch();
  }, []);

  const getCandidateResumeList = async () => {
    setResumesLoading(true);
    try {
      const candidateId = user?.candidate_id;
      if (candidateId !== null) {
        const response = await axios.post(
          `${Key.domain}/common/get_candidate_resumes_list`,
          { candidate_id: user?.candidate_id, user_id: user?.id }
        );
        if (response.status === 200) {
          const resumesData = response?.data?.data || [];
          if (resumesData.length > 0) {
            const primaryResume = resumesData.find(
              (resume) => resume.isPrimary === 1
            );
            const resumeToSelect = primaryResume || resumesData[0];
            setResumes(resumesData);
            setSelectedResume(resumeToSelect);
            dispatch(candidateSelectedResumeAction(resumeToSelect));
          } else {
            setResumes([]);
            setSelectedResume(null);
            setOpenFileUpload(true);
          }
        } else {
          setResumes([]);
          setSelectedResume(null);
        }
      } else {
        setResumes([]);
        setSelectedResume(null);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setResumes([]);
      setSelectedResume(null);
    } finally {
      setResumesLoading(false);
    }
  };

  const handleFileChange = (resume) => {
    setSelectedResume(resume);
    //console.log("Selected resume", resume);
  };
  const closeResumeParserModal = (isClose) => {
    setOpenFileUpload(!isClose);
    setResumesRefresh(isClose);
  };
  const popupsHandler = (msg, severity) => {
    if (msg) {
      handleOpenSnackbar(msg, severity);
      if (msg === "Resume added successfully") {
        setResumesRefresh(true);
      }
    }
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const handleOpenSnackbar = async (message, severity) => {
    await setSnackbarMessage(message);
    await setSnackbarSeverity(severity);
    await setSnackbarOpen(true);
  };
  const handleView = (view) => {
    setopen(view);
    setSelectedButton(view);
    // Perform additional actions based on the view (e.g., fetching data)
    if (view === "profile_view") {
      dispatch(getCandidateDetailAction(candidateDetails?.candidate_id));
    }
  };

  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );
  const hoverIconStyles = {
    height: isDesktopLarge
      ? "20px"
      : isDesktopMedium
        ? "18px"
        : isDesktopSmall
          ? "16px"
          : "13px",
    width: isDesktopLarge
      ? "20px"
      : isDesktopMedium
        ? "18px"
        : isDesktopSmall
          ? "16px"
          : "13px",
    color: "#616161",
    "&:hover": {
      bgcolor: "#F5F5F5",
      color: "#424242",
    },
  };

  const sendNotification = async () => {
    const notifyData = {
      user_id: user?.candidate_id,
      notifiedto: user?.user_id,
      notificationDescription: "Updated the Primary Resume ",
      notificationSubject: "Resume Updated",
      notificationType: "",
      job_id: "",
      candidate_name: user?.candidate_name,
      job_title: "",
    };
    await dispatch(creteNotificationAction(notifyData));
  };

  useEffect(() => {
    getPrimaryResumeDetails();
  }, [candidateDetails]);

  const getPrimaryResumeDetails = async () => {
    const updateData = {
      candidate_id: candidateDetails?.candidate_id,
    };
    const response = await dispatch(getPrimaryResumeDetailsAction(updateData));

    // Log the response to see the fetched data
    //console.log("Fetched Primary Resume Details:", response);

    // If needed, update your state or perform other actions here
  };

  const updateprimaryResume = async (resume_id) => {
    setLoading(true);
    const updatedData = {
      candidate_id: user?.candidate_id,
      resumeid: resume_id,
      primary: 1,
    };
    const response = await dispatch(updatePrimaryResumeAction(updatedData));
    if (response?.success === 1 && response?.data?.affectedRows > 0) {
      getPrimaryResumeDetails();
      handleOpenSnackbar(response?.messege, "success");
      getCandidateResumeList();
      setLoading(false);
    } else {
      handleOpenSnackbar("Failed to update primary resume", "error");
      setLoading(false);
    }
  };
  const handlePhoneChange = (value) => {
    setEditedPhone(value);

    if (!value) {
      setPhoneError(""); // No error if phone is blank (optional)
      return;
    }

    try {
      const phoneNumber = parsePhoneNumber(value);
      if (!phoneNumber) {
        setPhoneError("Invalid phone number");
        return;
      }

      const nationalNumber = phoneNumber.nationalNumber;

      if (nationalNumber.length > 10) {
        setPhoneError("Phone number cannot exceed 10 digits after country code");
        return;
      }

      if (nationalNumber.length < 10) {
        setPhoneError("Please enter exactly 10 digits after country code");
        return;
      }

      if (!isValidPhoneNumber(value)) {
        setPhoneError("Invalid phone number");
        return;
      }

      setPhoneError(""); // Valid number, clear error
    } catch (error) {
      setPhoneError("Invalid phone number format");
    }
  };
  const topBarStyles = {
    padding: "10px",
    borderRadius: "4px",
    border: "none",
  };

  const deleteResume = async (resumeId, primary) => {
    const resumeData = {
      resume_id: resumeId,
      user_id: user?.id,
    };
    if (primary === 1) {
      handleOpenSnackbar("Cannot delete primary resume", "error");
    } else {
      const candidateData = {
        candidate_id: user?.candidate_id,
        user_id: user.id,
      };
      await dispatch(deleteResumeAction(resumeData, candidateData));
      await getCandidateResumeList();
    }
  };

  const paperStyles1 = {
    borderRadius: "8px",
    flexGrow: 1,
    overflowY: "auto",
    padding: "1px",
  };

  const paperStyles0 = {
    borderRadius: "8px",
    flexGrow: 1,
    overflowY: "auto",
    padding: "1px",
  };

  const resumeCheckedHandler = (isCheck, resumeId) => {
    const resumeData = resumes.filter((data) => resumeId === data.resume_id);

    let extractedResumeId;
    if (resumeData.length > 0) {
      extractedResumeId = resumeData[0].resume_id;
    }
    if (isCheck) {
      setResumeCheckedLength(resumeCheckedLength + 1);
      setResumesChecked((prevChecked) => [...prevChecked, extractedResumeId]);
    } else {
      if (!isCheck) {
        setResumeCheckedLength(resumeCheckedLength - 1);
        setResumesChecked((prevChecked) =>
          prevChecked.filter((id) => id !== extractedResumeId)
        );
      }
    }
  };
  const handleEditClick = () => {
    setIsEditing(true);
    setEditPopupOpen(true);
    setEditedTitle(selectedResume?.application_title || "");
    setEditedPhone(selectedResume?.home_phone || "");
    setEditedLinkedIn(selectedResume?.linkedin_url || candidateDetails?.linkedin_url || "");
    setEditedGitHub(selectedResume?.github || candidateDetails?.github || "");
    setEditedSkype(selectedResume?.skype_id || candidateDetails?.skype_id || "");
    setEditedStackOverflow(selectedResume?.stack_overflow || candidateDetails?.stack_overflow || "");
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      // Validate input
      if (!selectedResume?.resume_id || !user?.candidate_id) {
        handleOpenSnackbar("Missing required fields", "error");
        return;
      }
      if (!editedTitle) {
        handleOpenSnackbar("Job Title is required.", "error");
        return;
      }
      // Only validate phone if not empty
      if (editedPhone && phoneError) {
        handleOpenSnackbar(phoneError, "error");
        return;
      }
      if (editedPhone && !isValidPhoneNumber(editedPhone)) {
        handleOpenSnackbar("Please enter a valid phone number", "error");
        return;
      }
      // Prepare payload for update
      const updateData = {
        application_title: editedTitle,
        home_phone: editedPhone,
        linkedin_url: editedLinkedIn,
        github_url: editedGitHub,
        skype_id: editedSkype,
        stackoverflow_url: editedStackOverflow
      };

      // Make API call to update resume details
      const response = await axios.put(
        `${Key.domain}/candidate/update-resume-details/${user?.candidate_id}/${selectedResume.resume_id}`,
        updateData,
      );

      if (response.data?.success) {
        setSelectedResume(prev => ({
          ...prev,
          application_title: editedTitle,
          home_phone: editedPhone,
          linkedin_url: editedLinkedIn,
          github_url: editedGitHub,
          skype_id: editedSkype,
          stackoverflow_url: editedStackOverflow
        }));

        setIsEditing(false);
        setEditPopupOpen(false);

        handleOpenSnackbar(response.data?.message || "Profile updated successfully", "success");

        await dispatch(getCandidateDetailAction(user?.candidate_id));
        await getCandidateResumeList();
      } else {
        // Handle backend errors
        const errorMessage = response.data?.message || "Failed to update profile";
        handleOpenSnackbar(errorMessage, "error");
        console.error('Backend error updating profile:', response.data);
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      handleOpenSnackbar(
        error.message || "Failed to update profile due to network or unexpected error",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const isValidString = (v) =>
    v !== undefined &&
    v !== null &&
    typeof v === "string" &&
    v.trim().length > 0 &&
    v.trim().toLowerCase() !== "null";


  const handleCancel = () => {
    setIsEditing(false);
    setEditPopupOpen(false);
    setEditedTitle(selectedResume?.application_title || "");
    setEditedPhone(selectedResume?.home_phone || "");
  };
  const renderProfilesLoadingSkeleton = () => (
    <Grid container sx={{ flexGrow: 1, overflow: "hidden", m: 0, width: "100%" }}>
      <Grid item xs={12} md={3} lg={3} sx={{ height: "100%", pt: "0 !important", pr: { xs: 0, md: 1 }, pb: { xs: 1, md: 0 } }}>
        <Paper elevation={2} sx={{ height: "100%", overflow: "hidden" }}>
          <Skeleton variant="text" width="40%" height={32} sx={{ m: 2 }} />
          <LoadingListSkeleton />
        </Paper>
      </Grid>
      <Grid item xs={12} md={9} lg={9} sx={{ height: "100%", pt: "0 !important" }}>
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", gap: 1 }}>
          <Paper elevation={3} sx={{ p: 2, border: "1px solid rgb(224, 230, 247)" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              <Skeleton variant="circular" width={130} height={130} animation="wave" />
              <Stack spacing={1} sx={{ flex: 1 }}>
                <Skeleton variant="rounded" width="50%" height={28} animation="wave" />
                <Skeleton variant="rounded" width="35%" height={20} animation="wave" />
                <Skeleton variant="rounded" width="60%" height={18} animation="wave" />
              </Stack>
            </Box>
          </Paper>
          <Paper elevation={2} sx={{ flexGrow: 1, minHeight: 400, p: 2 }}>
            <Skeleton variant="rounded" width="100%" height="100%" animation="wave" sx={{ minHeight: 360 }} />
          </Paper>
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ backgroundColor: "#f0f6fb", height: "calc(100vh - 65px)", display: "flex", flexDirection: "column", overflow: "hidden", pt: 1, pb: 0, mx: { xs: -0.5, md: -1 } }}>
      <Box sx={{ flexShrink: 0 }}>
        <Paper
          elevation={2}
          sx={{
            ...topBarStyles,
            margin: 0,
            marginBottom: "8px",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              spacing: 2,
              justifyContent: { xs: "center", sm: "space-between" },
            }}
          >
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={() => setOpenFileUpload(true)}
              disabled={resumesLoading}
              sx={{ textTransform: "none", backgroundColor: "#1565c0" }}
            >
              <AddCircleOutlineRoundedIcon />
              &nbsp;Resume
            </Button>

            <Box sx={{ flexGrow: 1 }} />

            <Box sx={{ display: selectedResume && !resumesLoading ? "block" : "none" }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "600",
                  fontSize: "1rem",
                  marginRight: "5px",
                  color: "#666666",
                }}
              >
                #{selectedResume?.resume_id} - {selectedResume?.full_name} -{" "}
                {selectedResume?.application_title}
              </Typography>
            </Box>

            {resumesLoading && (
              <Skeleton
                variant="rounded"
                width={280}
                height={20}
                animation="wave"
                sx={{ display: { xs: "none", sm: "block" } }}
              />
            )}

            <Box sx={{ flexGrow: 1 }} />
          </Box>
        </Paper>
      </Box>

      {resumesLoading ? (
        renderProfilesLoadingSkeleton()
      ) : !resumes?.length ? (
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 2,
            p: 4,
          }}
        >
          <Typography variant="h6" sx={{ color: "#666" }}>
            No resumes found
          </Typography>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setOpenFileUpload(true)}
            sx={{ textTransform: "none", backgroundColor: "#1565c0" }}
          >
            <AddCircleOutlineRoundedIcon />
            &nbsp;Add Resume
          </Button>
        </Box>
      ) : (
        <Grid container sx={{ flexGrow: 1, overflow: "hidden", m: 0, width: "100%" }}>
          <Grid item xs={12} sm={12} md={3} lg={3} sx={{ height: "100%", pt: "0 !important", pr: { xs: 0, md: 1 }, pb: { xs: 1, md: 0 } }}>
            <Paper
              elevation={2}
              sx={{
                height: "100%",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box>
                {resumes?.length > 0 && (
                  <Toolbar
                    sx={{
                      pl: { sm: 2 },
                      pr: { xs: 1, sm: 1 },
                      minHeight: "48px !important",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Typography variant="body1">My Resumes</Typography>
                      {/* <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={() => setOpenFileUpload(true)}
                >
                  Add
                </Button> */}
                      {resumeCheckedLength > 0 ? (
                        <Tooltip title="Delete Resume">
                          <IconButton
                            onClick={() =>
                              deleteResume(
                                selectedResume?.resume_id,
                                selectedResume?.isPrimary
                              )
                            }
                          >
                            <DeleteRounded />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                    </Box>
                  </Toolbar>
                )}
              </Box>

              <Divider />

              <Box sx={{ flexShrink: 0 }}>
                <List
                  subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                      Primary Resume
                      <VerifiedRounded
                        sx={{
                          color: "#ff9800",
                          height: "18px",
                          width: "18px",
                          ml: 1,
                        }}
                      />
                    </ListSubheader>
                  }
                  sx={{ overflow: "hidden" }}
                >
                  {true && (
                    <ListItemButton sx={{ borderBottom: "1px solid #ddd" }}>
                      <div style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}>
                        <p
                          style={{
                            fontSize: "0.85rem",
                            color: "rgba(0,0,0,0.7)",
                            fontWeight: 600,
                            margin: 0,
                            display: "flex",
                          }}
                        >
                          <span className="over-text" style={{ minWidth: "200px" }}>
                            {primaryResumeDetails?.full_name}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            margin: 0,
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span
                            style={{
                              flex: 1,
                              minWidth: 0,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Role: {primaryResumeDetails?.application_title || 'N/A'}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: '12px',
                            margin: 0,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <span
                            className="rol"
                            style={{
                              flex: 1,
                              minWidth: 0,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Experience: {primaryResumeDetails?.total_experience} years
                          </span>

                          <span
                            style={{
                              marginLeft: 'auto',        // pushes date to the right side
                              whiteSpace: 'nowrap',
                              color: '#757575',
                            }}
                          >
                            {primaryResumeDetails?.created
                              ? moment(primaryResumeDetails.created).fromNow()
                              : 'N/A'}
                          </span>
                        </p>
                      </div>
                    </ListItemButton>
                  )}
                </List>

                <p
                  style={{
                    color: "#00000099",
                    fontSize: "14px",
                    padding: "4px 16px 15px 16px",
                    margin: 0,
                  }}
                >
                  All Resumes
                </p>

              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f0f0f0",
                  },
                }}
              >
                {resumes?.length > 0 &&
                  [...resumes]
                    .sort((a, b) => {
                      const isAPrimary = parseInt(a.isPrimary) === 1 ? 1 : 0;
                      const isBPrimary = parseInt(b.isPrimary) === 1 ? 1 : 0;
                      return isBPrimary - isAPrimary;
                    })
                    .map((resume, index) => (
                    <Grid item xs={isMobile || isTablet ? 12 : 12} key={index}>
                      <ListItemButton
                        key={index}
                        sx={{
                          // boxShadow: "none",
                          // borderRadius: "8px",
                          padding: "0px",
                          mx: 1,
                          position: "relative",
                          overflow: "hidden",
                          backgroundColor:
                            selectedResume?.resume_id === resume?.resume_id
                              ? "rgba(25, 118, 210, 0.08)"
                              : "white",
                          "&:hover": {
                            ".more-icons": { display: "flex" },
                            backgroundColor: "#f5f5f5", // Hover background color for full coverage
                          },
                        }}
                        onClick={() => handleFileChange(resume)}
                        onMouseOver={() => setHoverIndex(index)}
                        onMouseLeave={() => setHoverIndex(null)}
                      >
                        <Grid container>
                          <Grid
                            item
                            xs={2}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Box sx={{ padding: "5px" }}>
                              <Checkbox
                                inputProps={{ "aria-label": "controlled" }}
                                onClick={(e) =>
                                  resumeCheckedHandler(
                                    e.target.checked,
                                    resume.resume_id
                                    // data?.email
                                  )
                                }
                              />
                            </Box>
                          </Grid>

                          {/* Main Content */}
                          <Grid
                            item
                            xs={10}
                            sx={{
                              p: 1,
                              cursor: "pointer",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              position: "relative",
                            }}
                          >
                            <Stack direction="column" spacing={0.5}>
                              <p
                                style={{
                                  fontSize: "0.85rem",
                                  color: "rgba(0,0,0,0.7)",
                                  fontWeight: 600,
                                  margin: 0,
                                  display: "flex",
                                }}
                              >
                                <span
                                  className="over-text"
                                  onClick={() => handleView("resume_view")}
                                >
                                  {resume.full_name}
                                </span>
                                <span
                                  style={{
                                    marginLeft: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {parseInt(resume.isPrimary) === 1 && (
                                    <Tooltip title="Primary Resume" arrow placement="top">
                                      <VerifiedRounded
                                        sx={{
                                          color: "#ff9800",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                  {parseInt(resume.isPrimary) === 0 && (
                                    <Tooltip
                                      title="Add to Primary"
                                      arrow
                                      placement="top"
                                    >
                                      <VerifiedRounded
                                        onClick={() => {
                                          updateprimaryResume(resume?.resume_id);
                                          sendNotification();
                                        }}
                                        className="hide-icons"
                                        sx={{
                                          height: "22px",
                                          width: "22px",
                                          color: "rgba(0,0,0,0.6)",
                                          p: "3px",
                                          display:
                                            hoverIndex === index ? "block" : "none", // Toggle visibility based on hover state
                                          "&:hover": {
                                            bgcolor: "rgba(255,255,255,0.8)",
                                            borderRadius: "4px",
                                          },
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                </span>
                              </p>

                              <p
                                style={{
                                  fontSize: '12px',
                                  margin: 0,
                                  display: 'flex',
                                }}
                              >
                                <span
                                  className="rol"
                                  style={{
                                    flex: 1,
                                    minWidth: 0,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Role: {resume?.application_title || 'N/A'}
                                </span>
                              </p>

                              <p
                                style={{
                                  fontSize: "12px",
                                  margin: 0,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span className="rol">
                                  Experience:{" "}
                                  {resume.total_experience.includes("+")
                                    ? resume.total_experience
                                    : `${resume.total_experience} years`}
                                </span>
                              </p>

                              {/* Timestamp Positioned on the Right */}
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  position: "absolute",
                                  right: hoverIndex === index ? "40px" : "8px", // Move left on hover
                                  bottom: "8px",
                                  color: "#757575",
                                  transition: "right 0.3s ease-in-out", // Smooth transition
                                }}
                              >
                                {resume.created
                                  ? moment(resume.created).fromNow()
                                  : moment("2022-03-31T06:26:04.138Z").fromNow()}
                              </Typography>

                              <Box
                                className="more-icons"
                                sx={{
                                  display: hoverIndex === index ? "flex" : "none", // Show on hover
                                  alignItems: "center",
                                  gap: "8px",
                                  position: "absolute",
                                  right: 8,
                                  bottom: 8,
                                  transition: "opacity 0.3s ease-in-out",
                                }}
                              >
                                <Tooltip title="Delete Resume">
                                  <IconButton
                                    aria-label="Delete resume"
                                    size="small"
                                    onClick={() =>
                                      deleteResume(
                                        resume?.resume_id,
                                        resume?.isPrimary
                                      )
                                    }
                                    sx={{ color: "#d32f2f", p: 0 }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>

                              <Box
                                className="more-icons"
                                sx={{
                                  display: "none",
                                  alignItems: "center",
                                  gap: "8px",
                                  position: "absolute",
                                  right: 8,
                                  bottom: 8,
                                  zIndex: 2, // Ensure icons appear above the timestamp
                                }}
                              >
                                <Tooltip title="Delete Resume">
                                  <IconButton
                                    aria-label="Delete resume"
                                    size="small"
                                    onClick={() =>
                                      deleteResume(
                                        resume?.resume_id,
                                        resume?.isPrimary
                                      )
                                    }
                                    sx={{ color: "#d32f2f", p: 0 }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Grid>
                        </Grid>
                      </ListItemButton>

                      {/* Divider between list items */}
                      <Divider sx={{ my: 1 }} />
                    </Grid>
                  ))}
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} sx={{ height: "100%", pt: "0 !important" }}>
            <Box
              sx={{
                height: "100%",
                overflowY: "auto",
                pb: 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid container alignItems="center">
                <Paper
                  elevation={3}
                  sx={{
                    marginBottom: "5px",
                    p: 2,
                    display: "flex",
                    border: "1px solid rgb(224, 230, 247)",
                    borderRadius: 2,
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    width: "100%",
                  }}
                >
                  {/* Left Section: Candidate Details */}
                  <Grid item xs={12} md={8}>
                    {/* Avatar & Candidate Info */}
                    <Box sx={{ position: "relative" }}>
                      <Button
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          minWidth: "auto",
                          padding: 1,
                          zIndex: 1,
                          color: isEditing ? "#4caf50" : "black"
                        }}
                        onClick={handleEditClick}
                      >
                        {isEditing ? <CheckBox /> : <ModeEditOutlineOutlinedIcon />}
                      </Button>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                          mb: 2,
                        }}
                      >
                        <Avatar
                          src={selectedResume?.image ? `${Key.aws_bucket_profile}/attachments/user_${selectedResume?.uid}/profileimages/${selectedResume?.image}` : null}
                          alt={selectedResume?.first_name || "Candidate Name"}
                          sx={{
                            width: "130px",
                            height: "130px",
                            fontSize: "25px",
                            boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                            border: "3px solid white",
                          }}
                        />

                        <Box>
                          <Typography
                            variant="h6"
                            sx={{ color: "rgb(5, 38, 78)", fontWeight: 600 }}
                          >
                            {selectedResume?.full_name}
                          </Typography>
                          <Typography variant="body2" sx={{ color: "gray" }}>
                            {selectedResume?.application_title || "Job Title"}
                          </Typography>
                          {/* Contact Info */}
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                            {isValidString(selectedResume?.email_address) ? (
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                                <Email sx={{ fontSize: 18, color: "gray" }} />
                                <Typography variant="body2" title={selectedResume?.email_address || "N/A"}>
                                  {typeof selectedResume?.email_address === "string"
                                    ? selectedResume.email_address.length > 25
                                      ? selectedResume.email_address.toLowerCase().slice(0, 25) + "..."
                                      : selectedResume.email_address.toLowerCase()
                                    : "N/A"}
                                </Typography>
                                <Verified sx={{ fontSize: 16, color: "green" }} />
                              </Box>
                            ) : ""}
                            {isValidString(selectedResume?.home_phone) ? (
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                                <Phone sx={{ fontSize: 18, color: "gray", ml: 2 }} />
                                <Typography variant="body2" title={selectedResume?.home_phone || "N/A"}>
                                  {typeof selectedResume?.home_phone === "string"
                                    ? selectedResume.home_phone.length > 11
                                      ? selectedResume.home_phone.slice(0, 11) + "..."
                                      : selectedResume.home_phone
                                    : "N/A"}
                                </Typography>

                                <Verified sx={{ fontSize: 16, color: "green" }} />
                              </Box>
                            ) : ""}
                          </Box>
                        </Box>
                      </Box>

                      {/* Social icons edit fields removed from view section */}
                      <Box sx={{ display: "flex", gap: 1 }}>
                        {(selectedResume?.linkedin_url || candidateDetails?.linkedin_url) && (
                          <IconButton
                            href={selectedResume?.linkedin_url || candidateDetails?.linkedin_url}
                            target="_blank"
                            sx={{
                              bgcolor: "rgba(0, 0, 0, 0.04)",
                              fontSize: 20,
                              width: 30,
                              height: 30,
                            }}
                          >
                            <FaLinkedinIn />
                          </IconButton>
                        )}
                        {(selectedResume?.github || candidateDetails?.github) && (
                          <IconButton
                            href={selectedResume?.github || candidateDetails?.github}
                            target="_blank"
                            sx={{
                              bgcolor: "rgba(0, 0, 0, 0.04)",
                              fontSize: 20,
                              width: 30,
                              height: 30,
                            }}
                          >
                            <FaGithub />
                          </IconButton>
                        )}
                        {(selectedResume?.skype_id || candidateDetails?.skype_id) && (
                          <IconButton
                            href={selectedResume?.skype_id || candidateDetails?.skype_id}
                            target="_blank"
                            sx={{
                              bgcolor: "rgba(0, 0, 0, 0.04)",
                              fontSize: 20,
                              width: 30,
                              height: 30,
                            }}
                          >
                            <FaSkype />
                          </IconButton>
                        )}
                        {(selectedResume?.stack_overflow || candidateDetails?.stack_overflow) && (
                          <IconButton
                            href={selectedResume?.stack_overflow || candidateDetails?.stack_overflow}
                            target="_blank"
                            sx={{
                              bgcolor: "rgba(0, 0, 0, 0.04)",
                              fontSize: 20,
                              width: 30,
                              height: 30,
                            }}
                          >
                            <FaStackOverflow />
                          </IconButton>
                        )}
                      </Box>
                      {/* Button Group (Resume/Profile) */}
                      <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        // mt: 2,
                        // mb: 2,
                        width: "100%"
                      }}>
                        <ButtonGroup
                          variant="contained"
                          sx={{
                            borderRadius: "8px",
                            overflow: "hidden",
                            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                            width: "fit-content"
                          }}
                        >
                          <Button
                            onClick={() => handleView("resume_view")}
                            sx={{
                              textTransform: "none",
                              fontSize: "14px",
                              padding: "8px 24px",
                              backgroundColor: selectedButton === "resume_view" ? "#0077B5" : "white",
                              color: selectedButton === "resume_view" ? "white" : "black",
                              fontWeight: 500,
                              borderRight: "1px solid #ccc",
                              "&:hover": {
                                backgroundColor: selectedButton === "resume_view" ? "#005A8C" : "#E0E0E0",
                              },
                            }}
                          >
                            📄 Resume
                          </Button>
                          <Button
                            onClick={() => handleView("profile_view")}
                            sx={{
                              textTransform: "none",
                              fontSize: "14px",
                              padding: "8px 24px",
                              backgroundColor: selectedButton === "profile_view" ? "#0077B5" : "white",
                              color: selectedButton === "profile_view" ? "white" : "black",
                              fontWeight: 500,
                              "&:hover": {
                                backgroundColor: selectedButton === "profile_view" ? "#005A8C" : "#E0E0E0",
                              },
                            }}
                          >
                            👤 Profile
                          </Button>
                        </ButtonGroup>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Right Section: Image */}
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        height: "auto",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={introImg}
                        alt="Self-introduction video"
                        style={{
                          width: "100%", // Ensure the image fits within bounds
                          height: "auto",
                          opacity: 0.5, // Reduced opacity for the background effect
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          color: "white",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          padding: "10px 20px",
                          borderRadius: "5px",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        Enhance your profile—video resume feature is on its way
                      </Box>
                    </Box>
                  </Grid>
                </Paper>
              </Grid>
              {/* <br /> */}

              {/* Main Content Section */}
              <Paper
                elevation={2}
                sx={{
                  ...paperStyles1,
                  flexGrow: 1,
                  minHeight: open === "resume_view" ? "800px" : "auto",
                  overflow: open === "resume_view" ? "hidden" : "visible",
                }}
              >
                {open === "resume_view" ? (
                  <ResumePdfViewer
                    resume_id={selectedResume?.resume_id}
                    file_name={selectedResume?.filename}
                    candidate_id={user?.candidate_id}
                  />
                ) : open === "profile_view" ? (
                  <CandidateDetailsView
                    candidateDetails={candidateDetails}
                    resume_id={selectedResume?.resume_id}
                  />
                ) : (
                  <></>
                )}
              </Paper>
            </Box>
          </Grid>
        </Grid>
      )}

      <Modal
        open={openFileUpload}
        onClose={() => {
          setOpenFileUpload(false);
          // dispatch(clearRedirect());
        }}
      >
        <Slide
          direction="left"
          in={openFileUpload}
          container={openFileUploadRef.current}
          mountOnEnter
          unmountOnExit
          timeout={{ enter: 1000, exit: 1000 }}
        //   style={{ transitionTimingFunction: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)'  }}
        >
          <Paper
            elevation={4}
            style={{
              transition: "opacity 2s ease-in-out",
              ...modalParseStyles,
            }}
          >
            <CandidateResumeUpload
              check="add_resumes"
              closeResumeParserModal={closeResumeParserModal}
              popupsHandler={popupsHandler}
              getCandidateResumeList={getCandidateResumeList}
            />
          </Paper>
        </Slide>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Edit Popup Dialog */}      <Dialog open={editPopupOpen} onClose={handleCancel} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Profile</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
            <TextField
              label="Job Title"
              value={editedTitle}
              onChange={(e) => setEditedTitle(e.target.value)}
              size="small"
              required
              error={!editedTitle}
              helperText={!editedTitle ? "Job Title is required" : ""}
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiInputBase-root": { height: "50px" },
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <Box
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: phoneError
                    ? "1.5px solid #d32f2f"
                    : "1.5px solid #c4c4c4",
                  borderRadius: "4px",
                  background: "#fff",
                  height: "50px",
                  transition: "border-color 0.3s",
                  "&:focus-within": {
                    borderColor: "#1976d2",
                  },
                }}
              >
                <Phone sx={{ fontSize: 20, color: "gray", ml: 1, mr: 1 }} />
                <Box
                  sx={{
                    flex: 1,
                    ".PhoneInput": { width: "100%" },
                    ".PhoneInputInput": {
                      width: "100%",
                      height: "48px",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      background: "transparent",
                      boxSizing: "border-box",
                      padding: "0 0 0 0",
                    },
                    ".PhoneInputCountry": {
                      marginRight: "8px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                    },
                    ".PhoneInputCountrySelect": {
                      height: "48px",
                    },
                  }}
                >
                  <PhoneInput
                    defaultCountry="US"
                    international
                    placeholder="Enter phone number"
                    value={editedPhone}
                    onChange={handlePhoneChange}
                    error={phoneError ? phoneError : undefined}
                  />
                </Box>
              </Box>
              {phoneError && (
                <Typography color="error" variant="caption" sx={{ ml: 1, mt: 0.5 }}>
                  {phoneError}
                </Typography>
              )}
            </Box>
            <TextField
              label="LinkedIn URL"
              value={editedLinkedIn}
              onChange={(e) => setEditedLinkedIn(e.target.value)}
              size="small"
              placeholder="https://www.linkedin.com/in/your-profile"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiInputBase-root": { height: "50px" },
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="GitHub URL"
              value={editedGitHub}
              onChange={(e) => setEditedGitHub(e.target.value)}
              size="small"
              placeholder="https://github.com/your-profile"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiInputBase-root": { height: "50px" },
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="Stack Overflow URL"
              value={editedStackOverflow}
              onChange={(e) => setEditedStackOverflow(e.target.value)}
              size="small"
              placeholder="https://stackoverflow.com/users/your-id"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiInputBase-root": { height: "50px" },
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{
          display: 'flex',
          justifyContent: 'space-between',
          px: 8,
          pb: 3,
          pt: 2
        }}>
          <Button
            onClick={handleCancel}
            variant="outlined"
            color="secondary"
            sx={{ width: "120px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            disabled={loading || !editedTitle}
            sx={{ width: "120px" }}
          >
            {loading ? <CircularProgress size={20} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const modalParseStyles = {
  position: "absolute",
  top: "20%",
  left: "35%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  maxHeight: "70vh",
  overflow: "scroll",
  // p: 4,
};
